import { AssetService } from './../../core/services/asset/asset.service';
import { ApplicationType, ModuleType } from 'rs-transfer';
import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { FileComponent } from '../../pages/shared-pages/file/file.component';
import { AuthService } from '../../core/services/auth/auth.service';
import {  transferEnv } from '../../app.constants';
import { Subject } from 'rxjs';
import { Asset } from './../../core/models/types';
@Component({
    selector: 'fileImporter',
    template: require('./file-importer.html'),
    // styles: [require('./file-importer.css')],
})
export class FileImporterComponent implements OnInit {
    @ViewChild(FileComponent) file: FileComponent;
    @Input() asset: Asset;
    AuthService;
    currentCompany;
    currentUser;
    comment;
    files = [];
    AssetService;

    static parameters = [AuthService];
    constructor(private authService: AuthService,  assetService: AssetService) {
        this.AuthService = authService;

        this.currentUser = this.AuthService.currentUser;
        this.AssetService = assetService;
        this.setCurrentCompany();
    }
    setCurrentCompany(){
        this.currentCompany = this.AuthService.currentSelectedCompany;
        this.AuthService.currentSelectedCompanyChanged.subscribe(company => {
            this.currentCompany = company;
        });
    }

    ngOnInit(){

    }
    docUpload(e){

    }

    uploadFiles(){
        this.file.files.push(this.file.file);
        this.file.addFiles("import", this.currentCompany._id);
    }


    onSelect(e){

    }
}
